import Rellax from 'rellax';

const ISMOBILE = window.matchMedia("only screen and (max-width: 768px)").matches

if(!ISMOBILE && document.querySelector('[data-rellax-speed]')){
  new Rellax('[data-rellax-speed]', {
    center: true,
    speed: -4
  });
}
